import React from "react";
import "./ProcessView.css";
import Grid from '@mui/material/Grid2';
import "react-big-calendar/lib/css/react-big-calendar.css";
import { GlobalContext } from "../../Context/GlobalContext";
import ProcessTable from "../../Components/ProcessTable/ProcessTable";

/**
 * A container component for displaying the process table. <br>
 * This component is part of the layout and is responsible for rendering the `ProcessTable` component
 * within a responsive grid layout. It also interacts with the `GlobalContext` to manage the current tab state.
 *
 * @component
 * @example
 * import ProcessView from '../Layout/ProcessView/ProcessView';
 * <ProcessView />
 * @returns {React.Component} - The `ProcessView` component.
 */
function ProcessView() {
  const ref = React.useRef(null);  
  const { refreshTable } = React.useContext(GlobalContext);

  /**
   * CSS styles for the container element.
   * @type {Object}
   * @property {string} maxHeight - The maximum height of the container.
   * @property {string} bgcolor - The background color of the container.
   * @property {number} flexGrow - The flex-grow value for the container.
   */
   const ContainerStyle = {
    maxHeight: "calc(100vh - 110px)",
    bgcolor: "white",
    flexGrow: 1
  };

  return (
    <div ref={ref} className="container_body" style={ContainerStyle}>
      <Grid container spacing={2}>
        <Grid size={{ md: 12, lg: 12 }} >
          <ProcessTable key={refreshTable}/>
        </Grid>
      </Grid>
    </div>
  );
}

export default ProcessView;
